export default __webpack_public_path__ + "static/media/BBC News.d28633b3.png";